import { makeStyles } from '@material-ui/core/styles';

export const useStyle = makeStyles((theme) => {
    return {
        content: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            position: 'relative',
            fontSize: '16px',
            width: '100%',
            padding: theme.spacing(1.2, 2.5),
        },
        title: {
            color: theme.palette.text.secondary,
            fontWeight: 500,
            fontSize: 13,
            margin: 0,
        },

        types: {
            display: 'flex',
            flexDirection: 'row',
            '& p': {
                fontWeight: 700,
                fontSize: 15,
                marginRight: 10,
            },
        },
        icon: {
            color: `${theme.palette.primary.main} !important`,
            fontSize: '24px',
            marginRight: theme.spacing(2),
        },
    };
});
